const intro = (
  <p>
    <strong>Mapa Rezydentur</strong> to nowoczesne narzędzie, które pozwala
    szybko i wygodnie znaleźć idealne miejsce na rezydenturę. Sprawdź dostępność
    miejsc w różnych województwach, porównaj warunki szkoleniowe i zdecyduj,
    gdzie najlepiej rozpocząć szkolenie specjalizacyjne.
  </p>
);

const content = (
  <>
    <h3>Co oferuje Mapa Rezydentur?</h3>
    <ul>
      <li>
        <strong>Interaktywny przegląd specjalizacji</strong> – wybierz
        specjalizację i sprawdź, gdzie możesz ją odbywać.
      </li>
      <li>
        <strong>Lokalizacja miejsc rezydenckich</strong> – przeglądaj dostępne
        placówki według regionów i miast.
      </li>
      <li>
        <strong>Statystyki rekrutacyjne</strong> – dowiedz się, gdzie jest
        największa konkurencja, a gdzie łatwiej dostać się na rezydenturę.
      </li>
      <li>
        <strong>Warunki szkoleniowe</strong> – porównaj szpitale pod względem
        jakości kształcenia, dostępu do nowoczesnych technologii i kadry
        dydaktycznej.
      </li>
      <li>
        <strong>Opinie i doświadczenia innych lekarzy</strong> – poznaj
        rzeczywiste warunki pracy i atmosferę w różnych ośrodkach.
      </li>
    </ul>

    <h3>Jak korzystać z Mapy Rezydentur?</h3>
    <ul>
      <li>
        <strong>Wybierz specjalizację</strong> – znajdź kierunek, który Cię
        interesuje.
      </li>
      <li>
        <strong>Przeglądaj dostępne lokalizacje</strong> – sprawdź, gdzie możesz
        rozpocząć rezydenturę.
      </li>
      <li>
        <strong>Porównuj warunki</strong> – dowiedz się, które placówki oferują
        najlepsze możliwości szkoleniowe.
      </li>
      <li>
        <strong>Zaplanuj swoją przyszłość</strong> – podejmij świadomą decyzję
        na podstawie rzetelnych danych.
      </li>
    </ul>

    <h3>Dlaczego warto skorzystać z Mapy Rezydentur?</h3>
    <ul>
      <li>
        <strong>Pełna aktualność</strong> – dane są na bieżąco aktualizowane,
        byś zawsze miał dostęp do najnowszych informacji.
      </li>
      <li>
        <strong>Łatwe porównanie opcji</strong> – oszczędź czas, porównując
        różne lokalizacje w jednym miejscu.
      </li>
      <li>
        <strong>Wiarygodne źródło informacji</strong> – treści tworzone przez
        ekspertów medycznych i lekarzy z doświadczeniem w rezydenturze.
      </li>
      <li>
        <strong>Bezpośredni dostęp do statystyk i opinii</strong> – poznaj
        realne warunki rekrutacji i pracy w różnych szpitalach.
      </li>
    </ul>

    <h3>Twoja przyszłość w Twoich rękach</h3>
    <p>
      Nie wybieraj rezydentury w ciemno – skorzystaj z{" "}
      <strong>Mapy Rezydentur</strong>, by znaleźć idealne miejsce do rozwijania
      swojej kariery medycznej. Znajdź najlepszą specjalizację i szpital dla
      siebie już dziś!
    </p>
  </>
);

export const residencyMapDescription = { intro, content };
